<template>
  <div class="p-2 border-l !border-gray-300 bg-white">
    <VCalendar is-expanded borderless title-position="center" :show-weeknumbers="false"
      class="custom-calendar !flex-grow !w-full" :attributes='calendarAttributes' @dayclick="handleDateClick"
      :show-overflow-days="true" :locale="{ id: 'en', firstDayOfWeek: 1, masks: { weekdays: 'WWW' } }" />
  </div>
</template>

<script>
import { Calendar as VCalendar } from 'v-calendar'
import moment from "moment";
export default {
  components: {
    VCalendar
  },
  data() {
    return {
      selectedDate: moment().format("MM-DD-YYYY"), // March 26, 2025

      events: [
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(1, 'days').format('MM-DD-YYYY'),
        moment().clone().add(2, 'days').format('MM-DD-YYYY'),
        moment().clone().add(5, 'days').format('MM-DD-YYYY'),
      ],
    };
  },
  computed: {
    calendarAttributes() {
      return [
        {
          key: 'selected',
          highlight: {
            //   backgroundColor: '#a855f7',
            //   borderRadius: '50%',
            //   contentClass: 'text-white font-bold',
          },
          dates: this.selectedDate,
        },
        {
          bar: 'red',
          dates: this.events,
        },
      ];
    },
  },
  methods: {
    handleDateClick(day) {
      this.selectedDate = day.date;
      console.log('Clicked Date:', day.date);
    },
  }
}
</script>

<style>
/* 🎨 Tailwind + custom styling for calendar cells */
.custom-calendar .vc-day-content {
  @apply w-12 h-12 flex items-center justify-center transition-all duration-150 text-base bg-white shadow-lg m-2 rounded-full;
}

/* 🎨 Tailwind + custom styling for calendar cells */
.custom-calendar .vc-day-content {
  @apply w-12 h-12 flex items-center justify-center transition-all duration-150 text-xl bg-white shadow-lg m-2 rounded-full;
}

.custom-calendar .vc-highlight-content-solid {
  @apply bg-[#BA90C6] border-0;
}

.custom-calendar .vc-day:hover .vc-day-content {
  @apply bg-[#BA90C6] text-white;
}

.custom-calendar .vc-day.is-not-in-month .vc-day-content {
  @apply !text-gray-400 !bg-gray-200 opacity-100 border-white border;
}

.custom-calendar .vc-weekdays {
  @apply my-5;
}

.custom-calendar .vc-weekday {
  @apply text-base leading-none font-medium rounded-2xl mx-1 px-3 py-1.5 text-white bg-[#4A628A];
}

.custom-calendar .vc-title {
  @apply text-center font-semibold text-2xl text-gray-800;
}

/* .custom-calendar .vc-nav-title {
    @apply flex items-center justify-center text-gray-800 font-semibold rounded-full bg-yellow-500;
  } */

.custom-calendar .vc-arrow {
  @apply !text-white !rounded-full !bg-yellow-500 !w-10 !h-10;
}
</style>